import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UtilsService } from 'src/app/services/utils/utils.service';
import {
  GoogleMapOptions, GoogleMapsMapTypeId, GoogleMaps, ILatLng, Polyline, Marker,
  GoogleMapsEvent, GoogleMap, LatLng
} from '@ionic-native/google-maps';
import { RestService } from 'src/app/services/rest/rest.service';

declare var google;

@Component({
  selector: 'app-map',
  templateUrl: './map.page.html',
  styleUrls: ['./map.page.scss'],
})
export class MapPage implements OnInit {

  // coordinates = [
  //   {
  //     lat: 40.415014,
  //     long: -3.696138,
  //     address: 'Av. de Pio XII 13, Madrid',
  //     status: 'In Progress'
  //   },
  //   {
  //     lat: 40.4481168,
  //     long: -3.6549295,
  //     address: 'Calle de Espronceda 30, Madrid',
  //     status: 'In Progress'
  //   },
  //   {
  //     lat: 40.4087956,
  //     long: -3.7125208,
  //     address: 'Calle de Zurbano 29, Madrid',
  //     status: 'Completed'
  //   }
  // ];
  coordinates = [];
  markers = [];
  @ViewChild('map', { static: false }) mapElement: ElementRef;
  map: any;
  destinationGoogleMaps = '';

  constructor(private utils: UtilsService,
    private rest: RestService) { }

  async loadMapWithCoordinates() {
    try {

      await this.utils.showLoading();
      const resp: any = await this.rest.getOpenSessions();
      console.log(resp);
      if (resp) {
        this.coordinates = resp.body;
        console.log(this.coordinates);
      }
      // this.coordinates.forEach(
      //   (coords, index) => {
      //     const aux = new google.maps.LatLng(coords.lat, coords.long);
      //     this.coordinates[index] = aux;
      //   }
      // );
      const allPos = this.coordinates.filter(elem => elem.lastPosition);
      const center: LatLng = new google.maps.LatLng(allPos[0].lastPosition.latitude, allPos[0].lastPosition.longitude);

      const mapOptions = {
        center,
        zoom: 11,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: true
      };
      // We create the map
      this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);


      // // TODO: No detecta este evento
      // this.map.on(GoogleMapsEvent.MAP_CLICK).subscribe((point) => {
      //   this.map.setZoom(11);
      //   this.map.setCenter(point.latLng);
      //   // this.map.setCenter(.getPosition());
      // });

      // This event listener calls addMarker() when the map is clicked.
      google.maps.event.addListener(this.map, 'click', (event) => {
        this.map.setZoom(17);
        this.map.setCenter(event.latLng);
      });
      this.coordinates.forEach(
        (coords, index) => {
          if (coords.lastPosition) {


            const marker = new google.maps.Marker({
              map: this.map,
              position: {
                lat: coords.lastPosition.latitude,
                lng: coords.lastPosition.longitude
              },
              icon: {
                url: this.getIcon('In Progress'),
                size: {
                  width: 40,
                  height: 40
                }
              },
              style: [
                {
                  featureType: 'poi',
                  stylers: [
                    {
                      visibility: 'off'
                    }
                  ]
                }
              ]
            });
            const infowindow = new google.maps.InfoWindow({
              content: `<h4>${coords.user.firstName + ' ' + coords.user.lastName}</h4>  <br> Nº de cargas: ${coords.user.cargas.length} <br> Zonas:
                          ${coords.user.zonas || 'Ninguna'}`
            });

            google.maps.event.addListener(marker, 'click', () => {
              this.map.setCenter(marker.getPosition());
              this.map.setZoom(16);
              infowindow.open(this.map, marker);
            });
          }
        }
      );

      await this.utils.hideLoading();
    } catch (error) {
      console.log(error);
      await this.utils.showToast('Error al cargar posición de repartidores', 'danger', 3000);
    }
  }

  getIcon(status: string) {
    switch (status) {
      case 'Completed': {
        return 'http://maps.google.com/mapfiles/kml/pal4/icon62.png';
      }
      case 'In Progress': {
        return 'http://maps.google.com/mapfiles/kml/pal4/icon15.png';
      }
      default: {
        return 'http://maps.google.com/mapfiles/kml/pal4/icon15.png';
      }
    }
  }

  onMapClick(e) {
    console.log(e);
    this.map.setCameraZoom(15);

  }

  async ngOnInit() {
    await this.loadMapWithCoordinates();
  }

}
